import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import ContestList from 'components/Contest/layouts/ContestList';
import { selectCounts } from 'mt-react-common/modules/main/reducers/static/states/counts/reducer';

const FinishedCompetitions = props => (
  <React.Fragment>
    <h1 className="page-header hidden-xs">
      <i className="fa fa-trophy fa-lg" />
      &nbsp;Конкурсы – <strong>Завершенные</strong>{' '}
      <span className="badge badge-primary badge-circle text-super">
        {props.counts.completed_contests.count}
      </span>
    </h1>
    <ContestList staticQueryParams={{ status: 4 }} />
  </React.Fragment>
);

FinishedCompetitions.propTypes = {
  // CONNECT STATES
  counts: PropTypes.shape({
    completed_contests: PropTypes.shape({
      count: PropTypes.number.isRequired
    }).isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  counts: selectCounts(state)
});

export default connect(mapStateToProps)(FinishedCompetitions);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Competitions/FinishedCompetitions/FinishedCompetitions.js